export default __webpack_public_path__ + "static/media/bb-poster-small-mobile.c0f05137.jpg";